import { type ReactNode } from "react";
import { Toaster as Sonner } from "sonner";
import { AlertCircle, AlertTriangle, Check, Info } from "lucide-react";

function ToastIconBox({ children, className }: { children: ReactNode; className: string }) {
  return (
    <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${className}`}>
      {children}
    </div>
  );
}

/**
 * Toaster global (montado no root do SPA).
 * O Sonner cria um container por posição:
 * - bottom-right → sistema / Cardápio (appToast)
 * - top-center → Caixa/PDV (caixaToast com position explícita)
 * Não desmonta ao fechar modais do Caixa.
 */
export function Toaster() {
  return (
    <Sonner
      className="app-toaster"
      position="bottom-right"
      richColors={false}
      closeButton
      expand={false}
      visibleToasts={1}
      offset={{
        top: "16px",
        right: "max(16px, env(safe-area-inset-right))",
        bottom: "max(16px, env(safe-area-inset-bottom))",
        left: "16px",
      }}
      mobileOffset={{
        top: "16px",
        left: "max(16px, env(safe-area-inset-left))",
        right: "max(16px, env(safe-area-inset-right))",
        bottom: "max(16px, env(safe-area-inset-bottom))",
      }}
      toastOptions={{ duration: 6000, classNames: { toast: "app-toast" } }}
      icons={{
        success: (
          <ToastIconBox className="bg-emerald-100 text-emerald-600">
            <Check className="h-4 w-4" strokeWidth={2.5} />
          </ToastIconBox>
        ),
        error: (
          <ToastIconBox className="bg-red-100 text-red-600">
            <AlertCircle className="h-4 w-4" strokeWidth={2.5} />
          </ToastIconBox>
        ),
        warning: (
          <ToastIconBox className="bg-amber-100 text-amber-600">
            <AlertTriangle className="h-4 w-4" strokeWidth={2.5} />
          </ToastIconBox>
        ),
        info: (
          <ToastIconBox className="bg-blue-100 text-blue-600">
            <Info className="h-4 w-4" strokeWidth={2.5} />
          </ToastIconBox>
        ),
      }}
      style={{ zIndex: 99999 }}
    />
  );
}
